const { api } = require("../api");

export const postCpAvailability = ({ response }) =>
  api.post(`/leader/urgent-modals/action?response=${response}`);
